import { ExamType } from './studies/exam-type';
import { AssignmentType } from './studies/assignment-type';
import { Major } from './studies/major';
import { AbstractCourse } from './studies/abstract-course';
import { SupervisoryInstitution } from './studies/supervisory-institution';
import { AbstractProgram } from './studies/abstract-program';
import { SettingsBranches } from './branches/settings-branches';
import { SettingsLecturersRateType } from './lecturers/settings-lecturers-rate-type';
import { WorkingYearsManagement } from './working-time-management/working-time-management';
import { SettingsDocsType } from './docs/settings-docs-type';
import { ScholarshipFundersEntities } from './scholarship-funders';
import { BuildingResponseWithClassesAttributes } from './buildings/building';
import { ClassAttributeType } from './class-attributes/class-attribute-types';
import { BaseEntity } from '../base-entity';
import { CourseStudentStatus } from './studies/course-student-status';
import { PaymentServiceWithVersionsResponseType } from '../payments/payment-template';
import { UserRoleEntity } from '../user/entities/user-role-entity';
import { UserSummaryType } from '../user/user-summary.type';
import { UserType } from '../user/user-type';
import { UserDetailsLecturerRes } from '../lecturers/user-details-lecturer';
import { UserDetailsStudent } from '../students/user-details-student';
import { SettingsUserRoleDocCreatedDefault } from './user-document-created-default/settings-user-role-doc-created-default';
import { SettingsCheckStatusPaymentServiceEntity } from './check-status-payment-service/check-status-payment-service';
import { AbstractExternalExam } from './studies/abstract-external-exam';
import globalSettingsStores from '../../../stores/settings-stores';

export type ProfessorProfile = UserDetailsLecturerRes;

export type StudentProfile = UserDetailsStudent;

export interface AdminProfile {
  //
  settings: SettingsAll;
}

export interface UserProfile {
  userType: UserType;
  userWithRole: UserSummaryType;
  profile: ProfessorProfile | StudentProfile | AdminProfile;
  baseFileUrl: string;
}

export interface SettingsAll {
  education: SettingsEducationAll;
  branches: SettingsBranches[];
  buildings: BuildingResponseWithClassesAttributes[];
  /*classAttributes: SettingsClassesAttributeEntity[];*/
  classAttributes2: ClassAttributeList[];
  paymentTypes: PaymentServiceWithVersionsResponseType[];
  scholarshipFunders: ScholarshipFundersEntities[];
  docTypes: SettingsDocsType[];
  lecturersTypeRateNames: SettingsLecturersRateType[];
  workingTimeManagement?: WorkingYearsManagement;
  userDefaultDocumentCreation: SettingsUserRoleDocCreatedDefault[];
  checkPaymentStatus: SettingsCheckStatusPaymentServiceEntity[];
  abstractPolls: PollWithQuestionsResponse[];
}

export interface PollOptionResponse {
  id: number;
  questionId: number;
  optionText: string;
  optionValue: number;
  optionOrder: number;
}

export enum PollQuestionType {
  multiple_choice = 'multiple_choice',
  free_text = 'free_text',
}

export interface PollQuestionResponse {
  id: number;
  abstractPollId: number;
  questionText: string;
  questionType: PollQuestionType;
  questionOrder: number;
  options: PollOptionResponse[];
}

export interface PollWithQuestionsResponse {
  id: number;
  pollName: string;
  questions: PollQuestionResponse[];
}

export interface ClassAttributeEntity extends BaseEntity {
  id: number;
  attributeName: string;
  attributeType: ClassAttributeType;
}

export interface ClassAttributeValueEntity extends ClassAttributeEntity {
  numericValue?: number;
  boolValue?: boolean;
}

export interface ClassAttributeList {
  listId: number;
  listName: string;
  attributes: ClassAttributeEntity[];
}

export interface ClassAttributeListValues extends ClassAttributeList {
  attributes: ClassAttributeValueEntity[];
}

export interface SettingsEducationAll {
  majors: Major[];
  courses: AbstractCourse[];
  programs: AbstractProgram[];
  assignments: AssignmentType[];
  exams: ExamType[];
  supervisoryInstitutions: SupervisoryInstitution[];
  courseStudentStatuses: CourseStudentStatus[];
  externalExams: AbstractExternalExam[];
}
